import { render, staticRenderFns } from "./HomepageTextBlock.vue?vue&type=template&id=756ad0d4&"
import script from "./HomepageTextBlock.js?vue&type=script&lang=js&"
export * from "./HomepageTextBlock.js?vue&type=script&lang=js&"
import style0 from "./HomepageTextBlock.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports